exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  DATATABLES */\ntable.dataTable {\n    border-collapse: collapse ;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {\n    line-height: 18px ;\n}\n\n.container-fluid.dt-bootstrap4 {\n    padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/postcss-loader?{"ident":"postcss"}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/vendors/datatables/datatables.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/datatables/datatables.css
// module chunks = styles